import * as React from 'react';
import { connect } from 'react-redux';
import { assign } from '../../shared/Assign';
import notify from '../../shared/feedback/notifications';
import * as Actions from './Actions';
import { Translate } from '../../shared/LanguageService';
import ProfileForm from './ProfileForm';
import { DroneAvailabilitySection } from './DroneAvailabilitySection';
import { handleError } from '../../shared/ErrorCatching';
import IProfileType from './IProfileType';
import * as Features from '../../shared/Features';

interface IProfilePageProps {
    actions: IProfilePageActions;
    profile: IProfilePageState;
    user: any;
}

interface IProfilePageActions {
    loadProfile: () => Promise<IProfileType>;
    saveProfile: (profile: IProfileType) => Promise<void>;
    uploadProfileImage: (image: any) => Promise<void>;
}

interface IProfilePageState {
    profile: IProfileType;
    timeZones: { id: string; name: string }[];
    availableLanguages: any[];
}

export class ProfilePage extends React.Component<IProfilePageProps, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            profile: {
                name: '',
                email: '',
                firstname: '',
                lastname: '',
                phoneNumber: '',
                languageKey: '',
                timeZoneId: ''
            },
            timeZones: [],
            errors: {},
            saving: false,
            imagePreviewUrl: '',
            image: {},
            imageWasUpdated: false,
            availableLanguages: []
        };

        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);
        this.onImageChange = this.onImageChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.actions
            .loadProfile()
            .then(() => {
                this.setState({
                    profile: assign({}, this.props.profile.profile),
                    timeZones: assign([], this.props.profile.timeZones),
                    availableLanguages: assign([], this.props.profile.availableLanguages)
                });
            })
            .catch(handleError);
    }

    onChange(e: any) {
        let input = this.state.profile;
        const value = e.target.value;
        input[e.target.name] = value;
        this.setState({ profile: assign({}, input) });
    }

    onImageChange(e: any): void {
        e.preventDefault();
        e.persist();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onloadend = () => {
            let image = e.target.files[0];
            image.data = reader.result;

            this.setState({ image: image, imageWasUpdated: true });
        };
        reader.readAsArrayBuffer(file);

        let dataUrlreader = new FileReader();
        dataUrlreader.onloadend = () => {
            this.setState({ imagePreviewUrl: dataUrlreader.result });
        };
        dataUrlreader.readAsDataURL(file);
    }

    save() {
        this.setState({ saving: true, errors: {} });
        this.props.actions
            .saveProfile(this.state.profile)
            .then(() => {
                if (this.state.imageWasUpdated)
                    this.props.actions.uploadProfileImage(this.state.image);
            })
            .then(() => {
                this.setState({ saving: false });
                notify.success(Translate('profile/page/notification/profile-saved'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, saving: false });
                })
            );
    }

    render() {
        let { imagePreviewUrl } = this.state;
        let imagePreview = null;
        if (this.state.profile.imageReference && !imagePreviewUrl) {
            const { apiUrl } = window.appConfig;
            imagePreview = <img src={`${apiUrl}/file/${this.state.profile.imageReference}`} />;
        } else if (imagePreviewUrl) {
            imagePreview = <img src={imagePreviewUrl} />;
        }
        return (
            <div>
                <h1>{Translate('profile/page/title')}</h1>
                <fieldset>
                    <ProfileForm
                        user={this.props.user}
                        profile={this.state.profile}
                        timeZones={this.state.timeZones}
                        errors={this.state.errors}
                        onChange={this.onChange}
                        save={this.save}
                        saving={this.state.saving}
                        imagePreview={imagePreview}
                        onImageChange={this.onImageChange}
                        availableLanguages={this.state.availableLanguages}
                        allowedToChangeUserName={Features.hasFeature(
                            Features.EditUserName,
                            this.props.user
                        )}
                    />
                </fieldset>
                <DroneAvailabilitySection user={this.props.user} />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        profile: state.profile,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            loadProfile: () => dispatch(Actions.loadProfile()),
            saveProfile: (profile) => dispatch(Actions.saveProfile(profile)),
            uploadProfileImage: (image) => dispatch(Actions.uploadProfileImage(image))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
